import { useRef } from "react";
import { Form, message, Button, Image } from 'antd';
import { YHModal } from "@/components/YHModal";
import { YhForm } from "@/components/YhFormBox";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { invoiceModel } from "@/views/invoice/manage/InvoiceModel";
import { uploadDataModel } from "./uploadDataModel";
import { invoiceManageService } from "@/views/invoice/manage/InvoiceManageService";
import { InvoiceIdentify } from "@/views/invoice/manage/InvoiceManageTypes";
import moment from 'moment';
import "@/views/invoice/manage/invoice-style.less";

export function Detail() {

    const { imageUrl } = invoiceModel();
    const { beDs, onSearchInvoiceNums, detailVisible, setDetailVisible, detail, setDetail, next } = uploadDataModel();
    const formRef = useRef<IYhFormRef>();
    const [form] = Form.useForm();

    const formConfig: IYhForm = {
        labelCol: { span: 10 },
        formValues: { ...detail, invoiceDate: moment(detail?.invoiceDate, 'YYYY-MM-DD') },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户名称",
                fieldName: "purchaserName",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "销售方名称",
                fieldName: "sellerName",
                span: 24,
                ds: beDs
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票号码",
                fieldName: "invoiceNum",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "开票名称",
                fieldName: "invoiceTypeName",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "开票日期",
                fieldName: "invoiceDate",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "发票类型",
                fieldName: "invoiceTypeCode",
                span: 24,
                ds: [
                    { label: "无票", value: "invoice-type.no" },
                    { label: "增值税普通发票", value: "invoice-type.vat-ordinary" },
                    { label: "增值税专用发票", value: "invoice-type.vat-special" }
                ]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "开票金额",
                fieldName: "amount",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "纳税人识别号",
                fieldName: "purchaserRegisterNum",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "地址、电话",
                fieldName: "purchaserAddress",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "开户行及账号",
                fieldName: "purchaserBank",
                span: 24,
            },
        ]
    };

    const saveData = async (record?: InvoiceIdentify) => {
        try {
            let formData = await formRef.current?.validateFields();
            if (formData) {
                const reqData = {
                    ...formData,
                    invoiceDate: moment(formData?.invoiceDate).format('YYYY-MM-DD'),
                    id: record?.id,
                    md5: record?.md5,
                    sellerName: formData?.sellerName ? beDs?.find(item => item.value === formData?.sellerName)?.label : "",
                };
                let insertRet = await invoiceManageService.invoiceUploadUpdate(reqData);
                if (insertRet) {
                    message.success("保存成功!");
                    setDetail(reqData);
                    onSearchInvoiceNums();
                } else {
                    message.error("保存失败!");
                }
            }
        }
        catch (errInfo) {
            console.log('数据保存异常:', errInfo);
        }
    };

    return (
        <YHModal
            width={1500}
            bodyHeight={700}
            visible={detailVisible}
            onCancel={() => { setDetailVisible(false) }}
            title="发票详情(点击图片放大)">
            <Form form={form} component={false}>
                <div>
                    <div id='invoiceDetailImageDiv' style={{ width: 1080, float: 'left', boxSizing: 'border-box', display: 'flex' }}>
                        <Image preview={false} style={{ maxWidth: 1080, maxHeight: 600 }} src={imageUrl(detail?.md5 ?? "")} />
                    </div>
                    <div style={{ width: 400, float: 'right', boxSizing: 'border-box', padding: '10px 50px 0px 0px', borderLeft: '1px solid #999999' }}>
                        <YhForm formRef={formRef} {...formConfig} />
                        <div className="flex justify-center items-center mt-30" >
                            <Button
                                className="mr-5"
                                type="link"
                                shape="round"
                                onClick={() => saveData(detail)}
                            >保存</Button>
                            <Button
                                className="mr-5"
                                type="default"
                                shape="round"
                                onClick={() => next(detail, -1)}
                            >上条</Button>
                            <Button
                                className="mr-5"
                                type="default"
                                shape="round"
                                onClick={() => next(detail, 1)}
                            >下条</Button>
                        </div>
                    </div>
                </div>
            </Form>
        </YHModal>
    )
}

